@if(variant === 'read-only'){
<div class="tag-container" [ngClass]="color">
  <div class="label-icon-container">
    @if(icon){
    <span class="material-symbols-outlined" [ngClass]="cssIconClass">{{ icon }}</span>
    }
    <p [ngClass]="size">{{ label }}</p>
  </div>
</div>
} @else{
<div class="tag-with-dropdown-container">
  <button class="tag-container" (click)="tagClickHandler()" [ngClass]="cssTagClassList">
    <div class="label-icon-container">
      @if(icon){
      <span class="material-symbols-outlined" [ngClass]="cssIconClass">{{ icon }}</span>
      } @if(variant === 'operational' && operationalContent?.length){
      <p [ngClass]="size">+{{ operationalContent?.length }}</p>
      }@else {
      <p [ngClass]="size">{{ label }}</p>
      } @if(variant === 'dismissable'){
      <button
        class="dismiss-button"
        tabindex="0"
        (keydown)="keyDownDismissHandler($event)"
        (click)="dismissClickHandler()"
      >
        <span class="material-symbols-outlined" [ngClass]="cssIconClass">close</span>
      </button>
      }
    </div>
  </button>
  @if(variant === 'operational'){
  <div [ngClass]="this.openDropdown ? 'opened-dropdown-container' : 'closed-dropdown-container'">
    @for(dropdownElement of operationalContent; track dropdownElement){
    <div>{{ dropdownElement }}</div>
    }
  </div>

  }
</div>
}
